export const SpaceTemplatesService = Symbol('SpaceTemplatesService');
